import type { DirectiveBinding } from 'vue';

import { pushEvent } from '@/utils/utils.js';

export const vGtmTrack = {
  mounted: (el: HTMLElement, binding: DirectiveBinding) => {
    const options = {
      root: null,
      rootMargin: '10px',
      // threshold: 0.5,
    };
    const observer = new IntersectionObserver(handleIntersect, options);
    observer.observe(el);
    let count = 0;
    function handleIntersect(entries: IntersectionObserverEntry[]) {
      entries.forEach((entry: IntersectionObserverEntry) => {
        if (entry.isIntersecting && count === 0) {
          count++;
          pushEvent({ event: `${binding.arg}_show`, name: `Affichage ${binding.arg}`, label: binding.value.product.id, data: binding.value });
        }
      });
    }

    el.addEventListener('click', () => {
      pushEvent({ event: `${binding.arg}_click`, name: `Clic sur ${binding.arg}`, label: binding.value.product.id, data: binding.value });
    });
  },
  unmounted: (el: HTMLElement, binding: DirectiveBinding) => {
    el.removeEventListener('click', () => {
      pushEvent({ event: `${binding.arg}_click`, name: `Clic sur ${binding.arg}`, label: binding.value.product.id, data: binding.value });
    });
  },
};
